import {daysToSec} from "../../../lib";

export default class Storage {
	constructor(courseId) {
		this.lang = document.querySelector('html').getAttribute('lang');
		this.storageName = this.lang + '_quiz_' + courseId;
		this.quizEntryId = null;

		this.quizTitle = null;
		this.iconUrl = null;
		// this.quizDescription = null;
		this.quizPassGrade = null;
		this.totalQuestions = null;
		this.questionList = null;
		this.currentQuestionIndex = null;
		this.ratio = null;

		this.deleteUserData();
	}

	init(quizEntryId) {
		this.quizEntryId = quizEntryId;
		const storageData = JSON.parse(localStorage.getItem(this.storageName));
		if (
			storageData &&
			storageData.hasOwnProperty(this.quizEntryId) &&
			storageData[this.quizEntryId].hasOwnProperty('data') &&
			!this.isExpired(storageData.expires)
		) {
			this.setData(
				storageData[this.quizEntryId].data.quizTitle,
				storageData[this.quizEntryId].data.iconUrl,
				storageData[this.quizEntryId].data.quizDescription,
				storageData[this.quizEntryId].data.quizPassGrade,
				storageData[this.quizEntryId].data.totalQuestions,
				storageData[this.quizEntryId].data.questionList,
				storageData[this.quizEntryId].data.currentQuestionIndex,
				storageData[this.quizEntryId].data.ratio
			);

			return true;
		}

		return false;
	}

	setData(
		quizTitle,
		iconUrl,
		quizDescription,
		quizPassGrade,
		totalQuestions,
		questionList,
		currentQuestionIndex,
		ratio = null
	) {
		this.quizTitle = quizTitle;
		this.iconUrl = iconUrl;
		// this.quizDescription = quizDescription;
		this.quizPassGrade = quizPassGrade;
		this.totalQuestions = totalQuestions;
		this.questionList = questionList;
		this.currentQuestionIndex = currentQuestionIndex;
		this.ratio = ratio;
	}

	getFilteredData() {
		const data = Object.assign({}, this);
		delete data.quizEntryId;
		data.questionList.forEach(question => {
			delete question.index;
			delete question.isAnswerCorrect;
		});
		return data;
	}

	indexUp() {
		if (this.currentQuestionIndex !== this.totalQuestions - 1) {
			this.currentQuestionIndex++;
		}
	}

	indexDown() {
		if (this.currentQuestionIndex !== 0) {
			this.currentQuestionIndex--;
		}
	}

	update(question) {
		this.questionList[this.currentQuestionIndex] = question;
		this.updateLocalStorage();
	}

	updateLocalStorage() {
		const emptyFields = this.checkData();
		if (emptyFields.length === 0) {

			let storageData = this.getOrCreateLocalStorageOfEntryData();
			storageData[this.quizEntryId]['data'] = Object.assign({}, this);
			const storageOfEntryIdData = storageData[this.quizEntryId]['data'];
			delete storageOfEntryIdData['quizEntryId'];

			const data = Object.assign({expires: Date.now() + daysToSec(10) * 1000}, storageData);
			data['lastVisited'] = this.quizEntryId;
			const serializedData = JSON.stringify(data);
			localStorage.setItem(this.storageName, serializedData);

		} else {
			console.error(`Local storage hasn\'t updated, some required properties have no values`, emptyFields);
		}
	}

	getLocalStorage() {
		const storageData = JSON.parse(localStorage.getItem(this.storageName));
		return storageData ? storageData : null;
	}

	getLocalStorageOfEntry() {
		const storageData = this.getLocalStorage();
		return ((storageData !== null && storageData.hasOwnProperty(this.quizEntryId)) ?
			storageData :
			null);
	}

	getLocalStorageOfEntryData() {
		const storageData = this.getLocalStorageOfEntry();

		return ((storageData !== null && storageData[this.quizEntryId].hasOwnProperty('data')) ?
			storageData :
			null);
	}

	getOrCreateLocalStorage() {
		let storageData = this.getLocalStorage();
		if (storageData === null) {
			console.warn('Local storage with name "quiz" does not exist. Empty object has been created.');
			storageData = {};
		}

		return storageData;
	}

	getOrCreateLocalStorageOfEntry() {
		let storageData = this.getOrCreateLocalStorage();

		if (!storageData.hasOwnProperty(this.quizEntryId)) {
			console.warn(`Local storage with name "quiz.${this.quizEntryId}" does not exist. Empty object has been created.`);
			storageData[this.quizEntryId] = {};
		}

		return storageData;
	}

	getOrCreateLocalStorageOfEntryData() {
		let storageData = this.getOrCreateLocalStorageOfEntry();

		if (!storageData[this.quizEntryId].hasOwnProperty('data')) {
			console.warn(`Local storage with name "quiz.${this.quizEntryId}.data" does not exist. Empty object has been created.`);
			storageData[this.quizEntryId]['data'] = {};
		}

		return storageData;
	}

	checkData() {
		const emptyFields = [];
		const keys = Object.getOwnPropertyNames(this);
		keys.forEach(key => {
			if (this[key] === null && key !== 'ratio' && key !== 'iconUrl') {
				emptyFields.push(key);
			}
		});
		return emptyFields;
	};

	saveResult() {
		const storageData = this.getLocalStorageOfEntryData();
		if (storageData !== null) {
			const storageOfEntryData = storageData[this.quizEntryId];
			delete storageOfEntryData['data'];
			storageOfEntryData.result = this.getResultGrade();
			localStorage.setItem(this.storageName, JSON.stringify(storageData));
		}
	}

	saveUserData(data) {
		const storageData = this.getOrCreateLocalStorage();
		if (data !== null) {
			storageData.userData = data;
			localStorage.setItem(this.storageName, JSON.stringify(storageData));
		} else {
			console.error('User data to save is not defined!');
		}
	}

	deleteUserData() {
		const storageData = this.getLocalStorage();
		if (storageData !== null && storageData.hasOwnProperty('userData')) {
			delete storageData['userData'];
			localStorage.setItem(this.storageName, JSON.stringify(storageData));
		}
	}

	getUserData() {
		const storageData = this.getLocalStorage();
		if (storageData !== null && storageData.hasOwnProperty('userData')) {
			return storageData['userData'];
		}
		return null;
	}

	getResultGrade() {
		const correctAnswers = +this.ratio.split('/')[0];
		const average = this.quizPassGrade + Math.ceil((this.totalQuestions - this.quizPassGrade) / 2);
		return correctAnswers < this.quizPassGrade ?
			'poor' :
			(correctAnswers < average ?
				'average' :
				'excellent');
	}

	isExpired(expirationTimestamp) {
		return Math.floor(expirationTimestamp / (1000 * 60 * 60)) === Math.floor(Date.now() / (1000 * 60 * 60));
	}
}